export class KamisadoFailure {
    static NOT_RIGHT_COLOR = () => $localize `This piece is not of the color you have to play.`;
    static DIRECTION_NOT_ALLOWED = () => $localize `You can only move forward, orthogonally or diagonally.`;
    static MOVE_BLOCKED = () => $localize `This move is blocked by another piece.`;
    static PLAY_WITH_SELECTED_PIECE = () => $localize `You must play with the selected piece.`;
}
